export const env = {
  LANDING_PAGE:
    import.meta.env.VITE_LANDINGPAGE || "https://www.aldcorporate.com.au/",
  DEPLOYMENT: import.meta.env.VITE_DEPLOYMENT,
  MAIN_DOMAIN: import.meta.env.VITE_MAINDOMAIN,
  BACKEND_URL: import.meta.env.VITE_BACKENDURL,
  SOCKET_URL: import.meta.env.VITE_SOCKET_BASEURL,
  CUSTOMER_PORTAL: import.meta.env.VITE_CUSTOMER_PORTAL,
  FILES_BASE_URL: import.meta.env.VITE_FILES_BASEURL,
  SIGNOZ_ACCESS_KEY: import.meta.env.VITE_SIGNOZ_ACCESS_KEY,
  SIGNOIZ_INGESTION_KEY: import.meta.env.VITE_SIGNOZ_INGESTION_KEY,
};
